export const SUPER_ADMIN = 'super_user';
export const ADMIN = 'admin';
export const USER = 'user';
export const GRANT_TYPE_PASSWORD = 'password';
